import React, { useEffect, useState, useRef } from "react";
import "animate.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "../../assets/css/transformation.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import Lady1 from "../../assets/img/smiles/1.webp";
import Lady2 from "../../assets/img/smiles/2.webp";
import Lady3 from "../../assets/img/smiles/3.webp";
import Lady4 from "../../assets/img/smiles/4.webp";
import Lady5 from "../../assets/img/smiles/5.webp";
import Lady6 from "../../assets/img/smiles/6.webp";
import Lady7 from "../../assets/img/smiles/7.webp";
import Lady8 from "../../assets/img/smiles/8.webp";
import Lady9 from "../../assets/img/smiles/9.webp";
import Lady10 from "../../assets/img/smiles/10.webp";
import Lady11 from "../../assets/img/smiles/11.webp";
import Lady12 from "../../assets/img/smiles/12.webp";
import Lady13 from "../../assets/img/smiles/13.webp";
import Lady14 from "../../assets/img/smiles/14.webp";
import Lady15 from "../../assets/img/smiles/15.webp";
import videoOne from "../../assets/videos/alignartest1.mp4";
import videoTwo from "../../assets/videos/alignertest2.mp4";
import videoThree from "../../assets/videos/alignertest3.mp4";
import videoFour from "../../assets/videos/alignertest4.mp4";
import SimpleVideoPlayer from "./video-player";
import thumbnailOne from "../../assets/img/thumbnail-video-one.webp";
import thumbnailtwo from "../../assets/img/thumbnail-video-two.webp";
import thumbnailthree from "../../assets/img/thumbnail-video-three.webp";
import thumbnailfour from "../../assets/img/thumbnail-video-four.webp";
import { useNav } from "../../context/nav-context";
import { useInView } from "react-intersection-observer";
const doctorProfiles = [
  {
    image: Lady1,
  },
  {
    image: Lady2,
  },
  {
    image: Lady3,
  },
  // {
  //   image: Lady8,
  // },
  {
    image: Lady4,
  },
  {
    image: Lady5,
  },
  {
    image: Lady6,
  },
  {
    image: Lady7,
  },
  // {
  //   image: Lady9,
  // },
  {
    image: Lady10,
  },
  {
    image: Lady11,
  },
  {
    image: Lady12,
  },
  {
    image: Lady13,
  },
  {
    image: Lady14,
  },
  {
    image: Lady15,
  },
];

const Transformation = () => {
  const swiperRef = useRef(null);

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };
  const [ref, inView] = useInView({
    triggerOnce: false, // Trigger animations each time the element comes into view
    threshold: 0.2, // Trigger when 20% of the component is visible
  });
  const { setActiveLink } = useNav();
  // Update activeLink to "journey" when this section is in view
  useEffect(() => {
    if (inView) {
      console.log("triggered");
      setActiveLink("transformations");
    }
  }, [inView, setActiveLink]);
  return (
    <div ref={ref} className="container mt-5" id="transformations">
      <div className="row align-items-center">
        <div className="col-lg-6 mb-3">
          <h2
            className={`fs-46 text-theme fw-400 text-center text-lg-start ${
              inView ? "animate__animated animate__fadeInUp" : ""
            }`}
          >
            Smile Transformations
          </h2>
          <p className="fs-16 fw-400">
            We’re proud to have transformed thousands of smiles - just have a
            look at the smiles from some of our patients
          </p>
        </div>
        <div className="col-lg-6 mb-3">
          <div className="d-flex justify-content-center justify-content-lg-end">
            <button onClick={goPrev} className="me-3 navigation-btn">
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
            <button onClick={goNext} className="navigation-btn">
              <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <Swiper
        ref={swiperRef}
        modules={[Navigation, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          440: {
            slidesPerView: 1,
          },
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
        className="doctor-row"
      >
        {doctorProfiles.map((doctor, index) => (
          <SwiperSlide key={index} className="doctor-col mt-2">
            <div className="doctor-card p-2 rounded-4">
              <img
                src={doctor.image}
                alt={doctor.name}
                className="img-fluid p-2 w-100 rounded-4"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="row mt-4">
        <div className="col-lg-6">
          <SimpleVideoPlayer
            src={videoOne}
            imageSrc={thumbnailOne}
            title={"Hear from Chen about his treatment"}
          />
        </div>
        <div className="col-lg-6">
          <SimpleVideoPlayer
            src={videoTwo}
            imageSrc={thumbnailtwo}
            title={"Hear from Shamimn about her treatment"}
          />
        </div>
        <div className="col-lg-6">
          <SimpleVideoPlayer
            src={videoThree}
            imageSrc={thumbnailthree}
            title={"Hear from Billy about her treatment"}
          />
        </div>
        <div className="col-lg-6">
          <SimpleVideoPlayer
            src={videoFour}
            imageSrc={thumbnailfour}
            title={"Hear from Lily about her treatment"}
          />
        </div>
      </div>
    </div>
  );
};

export default Transformation;
